// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-submit/orders-submit.less
// module id = 3782
// module chunks = 0